module.exports = __webpack_public_path__ + "static/media/landing-vaccine-icon.0a9666bc.png";